/**
 * InstructorPreviewMetadataStripComponent
 *
 * A compact "instructor metadata" strip used at the top of preview modals
 * (Content Hub module preview, unit preview via the embedded learner modal,
 * and any future instructor preview surface).
 *
 * Consolidates two banners that previously sat in awkward places:
 *  - The yellow "Instructor Override Active" notice (was inside the quiz panel).
 *  - The cyan "Students must complete the video before taking the quiz"
 *    rule (was below the split-screen player in the module modal).
 *
 * Pure dumb component: hides itself when both flags are false.
 */
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-instructor-preview-metadata-strip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './instructor-preview-metadata-strip.component.html',
  styleUrls: ['./instructor-preview-metadata-strip.component.scss']
})
export class InstructorPreviewMetadataStripComponent {
  /** True when the current viewer has instructor-style override authority
   *  AND the video is currently gating the quiz. */
  @Input() overrideActive = false;

  /** True when the underlying module declares `requireVideoCompletion === true`. */
  @Input() videoRequired = false;

  get visible(): boolean {
    return this.overrideActive || this.videoRequired;
  }
}
